import React from 'react';
import Headline from 'headline';
import Img from 'img';
import Icon from 'icon';
import helpers from 'utils/helpers';
import { Link, navigate } from 'gatsby';
import activeCategories from 'data/active-categories.json';
import CategoryPill from 'shared/category-pill';

import s from './article-card.module.scss';

export default function Card({
  image,
  featured_image = 'og-furlough',
  sponsored,
  title,
  categories,
  className,
  excerpt,
  date,
  slim,
  horizontal,
  main,
  noExcerpt,
  slug,
  footer,
  fullImage,
  resize,
  influencer,
  small,
  invert,
  short,
  slimLarge,
  slimLargeDesktop,
  inSlider,
  fixslug,
  ...props
}) {
  const titleTag = { h1: main, h3: !main };
  const dateString = helpers.getDateString(date);
  const author = props.author || '';
  const editor = props.editor ? `& ${props.editor}` : '';
  const illustrator = props.illustrator
    ? `Details by ${props.illustrator}.`
    : '';
  const authors = `${author} ${editor}`;
  const invertClass = invert ? s.invert : '';
  const shortClass = short ? s.short : '';
  const slimLargeClass = slimLarge ? s.slimLarge : '';
  const slimLargeDesktopClass = slimLargeDesktop ? s.slimLargeDesktop : '';
  const inSliderClass = inSlider ? s.inSlider : '';
  const propClasses = `
  ${slim ? s.slim : ''}
  ${fullImage ? s.fullImage : ''}
  ${horizontal ? s.horizontal : ''}
  ${className || ''} ${small ? s.small : ''}
  ${invertClass}
  ${shortClass}
  ${slimLargeClass}
  ${slimLargeDesktopClass}
  ${inSliderClass}
  `;

  return (
    <article
      className={`${s.card} ${propClasses}`}
      onClick={() => {
        navigate(`${fixslug ? '/' : ''}${slug}/`);
      }}
    >
      <div className={s.image}>
        <Img
          effect
          resize={resize}
          src={image || featured_image || 'placeholder-dark'}
          className={s.img}
          log
        />
        {sponsored && (
          <div className={s.sponsored}>
            SPONSORED
            <span className={s.fold} />
          </div>
        )}
      </div>
      <div className={`${s.content}`}>
        <Headline
          {...titleTag}
          el="h3"
          html={title || 'This is a title'}
          className={`${s.title} ${footer ? s.white : ''}`}
        />
        {excerpt && !noExcerpt && (
          <div
            className={s.excerpt}
            dangerouslySetInnerHTML={{
              __html:
                excerpt && excerpt.length > 365
                  ? `${excerpt.substr(0, 365)}...`
                  : excerpt
            }}
          />
        )}
        {
          <div className={s.categoryWrapper}>
            <div className={s.categories}>
              {categories
                ?.slice(0, 1)
                  // .filter(category =>
                  //   activeCategories.map(({ name }) => name).includes(category)
                  // )
                  .map(category => {
                    if (category === 'influencers' && categories.includes('lifestyle')) {
                      return 'lifestyle';
                    }
                    return category;
                  })
                  .map(category => (
                    <CategoryPill
                      key={category}
                      category={category}
                      className={s.pill}
                    />
                  ))}
            </div>
            <div className={s.date}>
              <p className={`${s.textWrapper}`}>
                <span className={`${s.textBlock} ${s.authorWrapper}`}>
                  <Icon className={s.icon} icon="user" />
                  <span className={s.metaText}>{author}</span>
                </span>
                <span className={`${s.separator} ${s.authorSeparator}`}>|</span>
                <span className={s.textBlock}>
                  <Icon className={s.icon} icon="clock" />
                  <span className={s.metaText}>{dateString}</span>
                </span>
                {influencer && (
                  <>
                    <span className={s.separator}>|</span>
                    <span className={s.textBlock}>
                      <Icon className={s.icon} icon="link-round" />
                      <span className={s.metaText}>{influencer}</span>
                    </span>
                  </>
                )}
              </p>
            </div>
            <span className={`font-bold color-text-light ${s.slimDate}`}>
              <Icon icon="clock" />
              <span>{dateString}</span>
            </span>
          </div>
        }
      </div>
    </article>
  );
}
